/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "sa-east-1",
    "aws_cognito_identity_pool_id": "sa-east-1:73d1c67f-36da-4f5b-b09a-e6b5c923172e",
    "aws_cognito_region": "sa-east-1",
    "aws_user_pools_id": "sa-east-1_poyS5WW5t",
    "aws_user_pools_web_client_id": "46at3s4bqvdmh616qfv37o3fv1",
    "oauth": {},
    "aws_cognito_username_attributes": [],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ]
};


export default awsmobile;